import ReportsList from "@/components/ReportsList";

export default function ReportEmployeesPage() {
  return (
    <ReportsList
      title="Report Dipendenti e Responsabili"
      filterTypes={["employee", "management"]}
      emptyText="Nessun report dipendente o responsabile. I report vengono generati automaticamente al completamento dell'analisi."
      testIdPrefix="reports-employees"
    />
  );
}
